import * as React from 'react';
import TextField from '@mui/material/TextField';
import { textfieldDateFormat } from "../utils/dateFunctions";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

const DatePickerOutline = (props) => {
    console.log('DatePickerOutline', props.date);
    console.log(dayjs('2000-01-01'));
    return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                <DatePicker  minDate={dayjs(props.minDate?props.minDate:'2000-05-11')} maxDate={dayjs(props.maxDate?props.maxDate:'2100-12-31')} format="DD/MM/YYYY" label={props.label} value={dayjs(props.date)}
                    onChange={(newValue) => props.setDate(newValue.toDate())} disabled={props.disabled} />
                </DemoContainer>
            </LocalizationProvider>
    )
}

export default DatePickerOutline;

export const DatePickerAutoOpen = (props) => {
    const [open, setOpen] = React.useState(true);
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
                <DatePicker format="DD/MM/YYYY" label={props.label} value={dayjs(props.date)} open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}
                    onChange={(newValue) => { props.setDate(newValue.toDate()) }} disabled={props.disabled} />
            </DemoContainer>
        </LocalizationProvider>
    )
}